var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LeadNoticationDetailComponent } from './lead-notication-detail';
var ɵ0 = {
    title: 'Lead'
};
var routes = [
    {
        path: '',
        component: LeadNoticationDetailComponent,
        data: ɵ0
    }
];
var NotificationRotingModule = /** @class */ (function () {
    function NotificationRotingModule() {
    }
    NotificationRotingModule = __decorate([
        NgModule({
            imports: [RouterModule.forChild(routes)],
            exports: [RouterModule]
        })
    ], NotificationRotingModule);
    return NotificationRotingModule;
}());
export { NotificationRotingModule };
export { ɵ0 };



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/views/notification-detail/notication-detail-routing.ts.pre-build-optimizer.js